import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {

  signLoader = false; captchaVal = false; captcha = "";
  keyObj: any = {}
  modalRef: NgbModalRef;
  userId: any;
  otpStatus: boolean = false;

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private modalService: NgbModal) { }

  ngOnInit() {
    this.userId = localStorage.getItem('userId')
    this.keyObj.address = localStorage.getItem('Address')
    this.keyObj.loginStatus = localStorage.getItem('login')
    this.conn.setPrivateKey.subscribe((res: any) => {
      this.keyObj.privateKey = res
    })
  }


  openbannermodel(content: any) {

    setTimeout(() => {
    if (this.keyObj?.loginStatus == false && this.otpStatus == true) {
        this.modalRef = this.modalService.open(content, { size: 'lg' });
        this.downloadFile(this.keyObj.privateKey)
    }
    else {
      this.route.navigateByUrl('explorer');
    }
  }, 3000)

  }

  submitFunc(otpForm: NgForm) {
    var data = otpForm.value;
    data.id = this.userId
    this.signLoader = true;
    this.conn.postUrl('users/verifyOtp', data).subscribe((res: any) => {
      if (res.status == 1) {
        this.conn.setLogin.emit(true)
        this.keyObj.privateKey = res.yeketavirp
        this.keyObj.loginStatus = res.loginStatus
        this.otpStatus = true
        localStorage.setItem('isLogin', 'true');
        localStorage.setItem('Sastana_Token', res.token);
        localStorage.setItem('Address', res.address);
        localStorage.setItem('loginStatus', res.loginStatus);
        this.alert.success('Logged in successfully');
        this.route.navigate(['/explorer'])
      } else {
        this.alert.error(res.msg);
        otpForm.resetForm();
        this.signLoader = false;
      }
    });
  }

  removeSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  checkLoginStatus() {
    this.conn.postUrl('users/loginStatus', { address: this.keyObj.address }).subscribe((res) => {
      if (res) {
        this.route.navigateByUrl('explorer');
      }
    })
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'pvtkeyfile.txt';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    window.scrollTo(0, 0);
    this.alert.success('Copied to the clipboard');
  }


}
